import { PaymentProviderEvent } from './payment-provider.event';

/**
 * Represents the state after payment provider has done the job
 */
export class NotSelectedPaymentProviderEvent extends PaymentProviderEvent {}
